import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import Downshift from "downshift";
import "./style.scss";

export default function TagsInput({ ...props }) {
    const { selectedTags, placeholder, tags, disabled, onError, ...other } = props;
    const [inputValue, setInputValue] = React.useState("");
    const [selectedItem, setSelectedItem] = React.useState([]);
    let count = 1
    useEffect(() => {
        count = count + 1;
        setSelectedItem(tags);
    }, [tags]);
    useEffect(() => {
        selectedTags(selectedItem);
    }, [selectedItem, selectedTags]);

    function handleKeyDown(event: any) {
        if (event.key === "Enter") {
            const newSelectedItem: any = [...selectedItem];
            const duplicatedValues = newSelectedItem.indexOf(
                event.target.value.trim()
            );

            if (duplicatedValues !== -1) {
                setInputValue("");
                return;
            }
            if (!event.target.value.replace(/\s/g, "").length) return;

            newSelectedItem.push(event.target.value.trim());
            setSelectedItem(newSelectedItem);
            setInputValue("");
            props.onChange(event.target.value.trim(), tags);
        }
        if (
            selectedItem.length &&
            !inputValue.length &&
            event.key === "Backspace"
        ) {
            setSelectedItem(selectedItem.slice(0, selectedItem.length - 1));
            props.onDelete(selectedItem);
        }
    }
    function handleChange(item: any) {
        let newSelectedItem: any = [...selectedItem];
        if (newSelectedItem.indexOf(item) === -1) {
            newSelectedItem = [...newSelectedItem, item];
        }
        setInputValue("");
        setSelectedItem(newSelectedItem);
    }

    const handleDelete = (item: any) => () => {
        const newSelectedItem: any = [...selectedItem];
        newSelectedItem.splice(newSelectedItem.indexOf(item), 1);
        setSelectedItem(newSelectedItem);
        props.onDelete(selectedItem);
    };

    function handleInputChange(event: any) {
        let value = event.target.value.toLowerCase()
        if(props.name && props.name === "Tags") {
            value = event.target.value;
        }
        setInputValue(value);
    }

    function handleBlur(val: string) {
        if(val?.trim() !== "") {
            if(onError) onError('Press Enter to add the tag', 'warning');
        }
    }

    return (
        <React.Fragment>
            <Downshift
                id="downshift-multiple"
                inputValue={inputValue}
                onChange={handleChange}
                selectedItem={selectedItem}
            >
                {({ getInputProps }: any) => {
                    const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
                        onKeyDown: handleKeyDown,
                        placeholder
                    });
                    return (
                        <div id="tag-input">
                            <TextField
                                margin="normal"
                                variant="standard"
                                InputProps={{
                                    startAdornment: selectedItem?.map(item => (
                                        <Chip
                                            key={item}
                                            tabIndex={-1}
                                            label={item}
                                            // margin: theme.spacing(0.5, 0.25)
                                            disabled={disabled}
                                            onDelete={handleDelete(item)}
                                        />
                                    )),
                                    onBlur: event => {
                                        handleBlur(inputValue);
                                    },
                                    onChange: event => {
                                        handleInputChange(event);
                                        onChange(event);
                                    },
                                    onFocus,
                                }}
                                disabled={disabled}
                                {...other}
                                {...inputProps}
                            />
                        </div>
                    );
                }}
            </Downshift>
        </React.Fragment>
    );
}
TagsInput.defaultProps = {
    tags: []
};
TagsInput.propTypes = {
    selectedTags: PropTypes.func.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string)
};
